import React from 'react';
import Header from '../Header';
import { Box, Paper, CircularProgress } from '@mui/material';
import { useBranding } from '../../hooks/useBranding';

const Layout = ({ children }) => {
    const { branding, loading } = useBranding();

    if (loading || !branding) {
        return (
            <Box sx={{ minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <CircularProgress />
            </Box>
        );
    }

    const page = {
        background: branding.primaryColor,
        minHeight: '100vh',
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
    };

    return (
        <Box sx={page}>
            <Box sx={{ padding: 2 }}>
                <Paper elevation={3} sx={{ margin: '0 auto', maxWidth: 1280, padding: 2, paddingBottom: 4 }}>
                    <Header />
                    {children}
                </Paper>
            </Box>
        </Box>)
};

export default Layout;
